import ReactGA from 'react-ga4';

export const initGA = () => {
    // Inicializar Google Analytics (substitua pelo seu ID depois)
    ReactGA.initialize('G-B34RJLPXBR');
};

export const sendPageView = () => {
    ReactGA.send("pageview");
};
